export default __webpack_public_path__ + "static/images/logo.1b62c1506ae17acd6552365626d4b6f8.png";